<h1 mat-dialog-title>Tastenkombinationen</h1>
<div mat-dialog-content>
    @for (section of sections; track section.title) {
        <div class="section">
            <h2>{{ section.title }}</h2>
            <ul>
                @for (shortcut of section.shortcuts; track shortcut.keys) {
                    <li>
                        <span class="shortcut-keys">{{ shortcut.keys }}</span>
                        <span class="shortcut-action">{{ shortcut.action }}</span>
                    </li>
                }
            </ul>
        </div>
    }
</div>
<div mat-dialog-actions>
    <button mat-button (click)="close(false)">Schließen</button>
    <button mat-flat-button color="accent" (click)="close(true)">Verstanden</button>
</div>
